// Per-lane pipe lists (`no||no`). Pure, so the node tests reach it — both the band
// maths in laneBands.js and the classifier in restrictionClass.mjs split lists here.
import { isOffsetSectionedValue } from "./stepSections.mjs";

/**
 * Split a per-lane pipe list into one entry per lane. A blank slot is meaningful —
 * "allowed" for an access tag, "not applicable" for hov — so empty entries are
 * kept, including trailing ones ("no|" is two lanes, not one).
 * @param {string|undefined} value
 * @returns {string[]} one entry per lane; [] when there is no value at all
 */
export function splitLaneList(value) {
  if (value === undefined || value === null || value === "") return [];
  // Whitespace-only is nothing, not one blank lane. `" "` used to come back as
  // `[""]`, and since a length of 1 beats the `lanes=N` tier it overrode a correct
  // count with 1. A lone `"|"` survives this — that IS two unspecified lanes.
  if (String(value).trim() === "") return [];
  // A value that is still an LR chain is not a per-lane list, and must not be split
  // into one. styleBySection normally resolves step tags to scalars before classify()
  // sees them, but its whole-feature fallbacks — non-LineString geometry, zero
  // lengthCm, an undecodable chain — pass the RAW tags through. A per-lane step value
  // nests the pipe list inside the step value (`0-1000#yes||yes`), so splitting it
  // yields a slot that is exactly "yes" and the whole way renders as restricted, and a
  // lane count invented from wherever the pipes happened to fall. Exact-match slot
  // comparison does not protect against this; only refusing to split does.
  if (isOffsetSectionedValue(value)) return [];
  return String(value)
    .split("|")
    .map((entry) => entry.trim());
}
